/*  ========================================================================
    # Scripts - Text Media Gallery
    ========================================================================  */

/**
 * Script to handle the text media gallery motion.
 */

import { animate, scroll } from 'motion';

const TextMediaGallery = {
  cfg: {
    containers: document.querySelectorAll('.s-text-with-media--gallery')
  },

  addMotionToGallery() {
    this.cfg.containers.forEach(container => {
      const items = container.querySelectorAll(
        'figure[class^="s-text-with-media__gallery-item"], figure[class*=" s-text-with-media__gallery-item"]'
      );

      const translateVars = [
        { x: -10, y: -45 },
        { x: -20, y: 30 },
        { x: 10, y: -50 }
      ];

      items.forEach((item, index) => {
        const animation = animate(
          item,
          {
            x: [0, translateVars[index].x],
            y: [0, translateVars[index].y]
          },
          {
            ease: 'easeInOut'
          }
        );
        scroll(animation, { target: container, offset: ['start end', 'end start'] });
      });
    });
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.containers) {
      this.addMotionToGallery();
    }
  }
};

export default TextMediaGallery;
